import type { Step } from 'react-joyride'

// Three steps on QuoteCreate. Fires the first time a consultant lands here —
// usually right after clicking "Create quote" from a recommendation.
export const quoteCreateSteps: Step[] = [
  {
    target: '[data-tour="quote-header"]',
    title: 'Building the quote',
    content: 'A quote is what the farmer signs off on. You\'ll walk through who, what, and how much — then save and send.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="quote-step-indicator"]',
    title: 'Step by step',
    content: 'Use these tabs to move through the quote. You can jump back to any step to edit — nothing\'s locked until you save.',
    skipBeacon: true,
    placement: 'bottom',
  },
  {
    target: '[data-tour="quote-step-indicator"]',
    title: 'Pricing not loaded yet?',
    content: 'During the 2027 rollout some products show without prices. You can still build the quote — just leave price blank and add it when Ryan\'s supplier file lands.',
    skipBeacon: true,
    placement: 'bottom',
  },
]
